import React from "react";

import { RaisedButton, FlatButton, Checkbox, TextField } from "material-ui";

import { formatPrice } from "../../../util";

import CashChangeWidget from "../cash-change-widget.jsx";
import BaseOverlay from "../overlays/base.jsx";

class BoxOfficePayment extends React.Component {
  constructor(props) {
    super(props);
  }

  getStyles() {
    return {
      text: {
        margin: "1em 0"
      },
      externalIntro: {
        marginTop: "2em"
      },
      externalTotal: {
        margin: "0.5em 0 1.5em",
        fontSize: 30,
        fontWeight: "bold"
      },
      externalButton: {
        marginBottom: "1em"
      }
    };
  }

  render() {
    const styles = this.getStyles();

    let {
      orderData,
      processedData,
      headerStyle,
      orderInProgress,
      orderErrorMessage,
      eventBucket,
      externalNeedsConfirm
    } = this.props;

    let ready =
      orderData.missingRequiredFields === false &&
      orderData.subitems.filter(i => !i.service_fee).length &&
      (orderData.customerType === "groupSales" ||
        !orderData.subitems.some(i => i.seats && i.seats.length === 0)) &&
      (processedData.total === 0 ||
        orderData.paymentType === "terminal" ||
        orderData.paymentType === "cash" ||
        orderData.paymentType === "external" ||
        orderData.paymentType === "check" ||
        (orderData.person && orderData.paymentType === "saved") ||
        (orderData.paymentType === "card" &&
          orderData.paymentCardDetails &&
          orderData.paymentCardDetails.number &&
          orderData.paymentCardDetails.exp_year));

    let ticketQuantity = orderData.subitems
      .filter(i => i.ticket_bucket)
      .reduce((c, i) => i.quantity + c, 0);

    return (
      <div>
        <BaseOverlay
          open={externalNeedsConfirm}
          onRequestClose={this.props.cancelExternal}
          useMuiDefaultStyle={true}
          dialogContentStyle={{ maxWidth: 400, textAlign: "center" }}
          showCloseButton={true}
        >
          <div style={styles.externalIntro}>Collect external payment.</div>
          <div style={styles.externalTotal}>
            {formatPrice(processedData.total)}
          </div>
          <RaisedButton
            primary={true}
            label={"Mark as paid"}
            style={styles.externalButton}
            onClick={this.props.submitOrder}
          />
        </BaseOverlay>
        <div style={headerStyle}>Confirm order</div>
        <div style={styles.text}>
          {processedData.total === 0 ? (
            <div>
              The order total is {formatPrice(0, true)}, so the customer will
              not be charged.
            </div>
          ) : orderData.paymentType === "check" ? (
            <div>
              <div>
                Collect a check in the amount of{" "}
                {formatPrice(processedData.total)} from the customer, then click
                "Place order".
              </div>
              <TextField
                floatingLabelText="Check number"
                floatingLabelFixed={true}
                hintText={"123456"}
                value={orderData.check_number}
                onChange={e =>
                  this.props.updateCurrentOrder({
                    check_number: e.target.value
                  })
                }
                style={{
                  display: "block",
                  width: 300,
                  marginTop: -6,
                  marginBottom: 6
                }}
              />
            </div>
          ) : orderData.paymentType === "external" ? (
            <div>
              When you click "Place order", the customer will be prompted to pay{" "}
              {formatPrice(processedData.total)}.<br /> Follow the instructions
              on your external POS to complete the order.
            </div>
          ) : orderData.paymentType === "terminal" ? (
            <div>
              When you click "Place order", the customer will be prompted to pay{" "}
              {formatPrice(processedData.total)}.<br /> Follow the instructions
              on Eventive Terminal to complete the order.
            </div>
          ) : orderData.paymentType === "cash" ? (
            <div style={{ marginBottom: "1em" }}>
              <CashChangeWidget total={processedData.total} />
              {/*<div>Collect {formatPrice(processedData.total)} in cash from the customer, then click "Place order".</div>*/}
            </div>
          ) : (
            <div>
              When you click "Place order",{" "}
              {orderData.paymentType === "saved" && orderData.person
                ? `the customer's saved ${orderData.person.details.payment_method_summary} `
                : `the customer's card ${
                    orderData.paymentCardDetails &&
                    orderData.paymentCardDetails.number
                      ? `ending in ${orderData.paymentCardDetails.number.slice(
                          -4
                        )}`
                      : ""
                  } `}
              will be charged {formatPrice(processedData.total)}.
            </div>
          )}
          {orderData.person ||
          (orderData.group_sale_data && orderData.group_sale_data.length) ? (
            <div>
              A receipt will{orderData.suppress_email_confirmation ? " NOT " : " "}be emailed to "
              {orderData.group_sale_data
                ? orderData.group_sale_data.map(s => s.email).join('", "')
                : orderData.person && orderData.person.details.email}
              ".
            </div>
          ) : null}
        </div>
        {orderErrorMessage ? (
          <div
            style={Object.assign({}, styles.text, {
              color: "red",
              maxWidth: 500
            })}
          >
            {orderErrorMessage}
          </div>
        ) : null}
        {ticketQuantity && eventBucket.box_office_show_mark_scanned ? (
          <div>
            <Checkbox
              style={{ margin: "0 0 1em" }}
              label={`Mark ${
                ticketQuantity !== 1 ? "all" : "the"
              } ${ticketQuantity} ticket${ticketQuantity !== 1 ? "s" : ""} in ${
                orderData.group_sale_data ? "each" : ""
              } order as scanned`}
              checked={orderData.mark_as_used}
              onCheck={() =>
                this.props.updateCurrentOrder({
                  mark_as_used: !orderData.mark_as_used
                })
              }
            />
          </div>
        ) : null}
        {this.props.showEmailSuppressionCheckbox ? (
          <div>
            <Checkbox
              style={{ margin: "0 0 1em" }}
              label="Do not send confirmation email to customer"
              checked={orderData.suppress_email_confirmation}
              onCheck={() =>
                this.props.updateCurrentOrder({
                  suppress_email_confirmation: !orderData.suppress_email_confirmation
                })
              }
            />
          </div>
        ) : null}
        <RaisedButton
          primary={true}
          disabled={!ready || orderInProgress}
          label={
            orderInProgress
              ? `Placing order...`
              : `Place order (${formatPrice(processedData.total)})`
          }
          onClick={this.props.submitOrder}
        />
      </div>
    );
  }
}

export default BoxOfficePayment;



// WEBPACK FOOTER //
// ./src/app/components/partials/box-office/box-office-confirm.jsx